import Components from "slotworks/components/components";
import Translations from "slotworks/i18n/translations";
import BetMenuFreespinsMediator from "slotworks/mediators/bet-menu-freespins-mediator";
import Gamestate from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import SmartButton from "slotworks/smart-button/smart-button";
import { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import State from "slotworks/state-machine/states/state";

export default class RetriggerFreespins extends State {
    public onEnter() {
        SmartButton.setFlag(SmartButtonFlag.PROMPT, true);
        const record = Gamestate.getCurrentGame().getCurrentRecord() as SpinRecord;

        const contents = new Map<string, string>();
        contents.set("winMessage", Translations.get("fs.rtr", { VALUE: record.freespinsWon, SPINS: record.freespinsWon }));
        contents.set("value", record.freespinsWon.toString());

        Components.prompt.show(["freespinsretrigger", "freespinswin", "freespins"], contents).then(() => this.complete());
    }

    public complete() {
        SmartButton.setFlag(SmartButtonFlag.PROMPT, false);

        new BetMenuFreespinsMediator().start().execute();

        super.complete();
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/state-machine/standard/states/retrigger-freespins.ts